module.exports = __webpack_public_path__ + "img/00040.cb0ff0a4.webp";